import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScullyRoutesService } from '@scullyio/ng-lib';
import { combineLatest } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { SEOService } from '../../services/seo.service';

@Component({
  selector: 'app-blog-post',
  templateUrl: './blog-post.component.html',
  styleUrls: ['./blog-post.component.scss']
})
export class BlogPostComponent implements OnInit {

  pageTitle = "Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere"
  shareImg = "blog/";

  constructor(
    private activatedRoute: ActivatedRoute,
    private scully: ScullyRoutesService,
    private seo: SEOService
  ) {}

  $blogPostMetadata = combineLatest([
    this.activatedRoute.params.pipe(pluck('postId')),
    this.scully.available$
  ]).pipe(
    map(([postId, routes]) =>
      routes.find(route => route.route === `/blog/${postId}`)
    )
  );

  blog$ = this.scully.getCurrent();

  ngOnInit(): void {
    this.blog$.subscribe((b) => {
      this.seo.updatePageTags(b.pageTitle + " | " + this.pageTitle, this.desc, this.shareImg + b.shareImg);
    });
  }
}